import { MealType } from './mealType';
import { useTranslation } from 'react-i18next';

export const getMealTypeKey = (type: MealType) => {
  switch (type) {
    case MealType.NonVeg:
      return 'non-veg';
    case MealType.Vegan:
      return 'vegan';
    case MealType.Vegetarian:
      return 'vegetarian';
    default:
      return '';
  }
};

export const useMealType = (type: MealType) => {
  const { t } = useTranslation();

  return {
    name: t(`meal-types.${getMealTypeKey(type)}`),
    value: type,
    color:
      type === MealType.NonVeg
        ? '#F44336'
        : type === MealType.Vegan
          ? '#FF8C00'
          : '#4CAF50',
  };
};

export const useMealTypes = () => {
  return {
    [MealType.NonVeg]: useMealType(MealType.NonVeg),
    [MealType.Vegan]: useMealType(MealType.Vegan),
    [MealType.Vegetarian]: useMealType(MealType.Vegetarian),
  };
};
